import React from 'react';
// Remover a importação do framer-motion temporariamente
// import { motion } from 'framer-motion';

/**
 * Componente para exibir um template individual na lista
 * Design minimalista inspirado no Instagram
 * 
 * @param {Object} props - Propriedades do componente
 * @param {Object} props.template - Dados do template
 * @param {Function} props.onEdit - Função para editar o template
 * @param {Function} props.onView - Função para visualizar o template
 * @returns {JSX.Element} Componente React
 */
const TemplateCard = ({ template, onEdit, onView }) => {
  // Obter primeiras linhas do conteúdo para prévia
  const previewContent = template.message
    ?.split('\n')
    .slice(0, 2)
    .join('\n')
    .substring(0, 65) + (template.message?.length > 65 ? '...' : '');
  
  // Mapear tipos de template para cores de badge
  const getTypeColor = (type) => {
    const typeColors = {
      confirmacao: 'bg-green-100 text-green-800',
      lembrete: 'bg-blue-100 text-blue-800',
      agradecimento: 'bg-purple-100 text-purple-800',
      cancelamento: 'bg-red-100 text-red-800',
      reagendamento: 'bg-yellow-100 text-yellow-800',
      aniversario: 'bg-pink-100 text-pink-800',
      promocao: 'bg-indigo-100 text-indigo-800'
    };
    
    return typeColors[type] || 'bg-gray-100 text-gray-800';
  };
  
  // Mapear tipos para nomes amigáveis
  const getTypeName = (type) => {
    const typeNames = {
      confirmacao: 'Confirmação',
      lembrete: 'Lembrete',
      agradecimento: 'Agradecimento',
      cancelamento: 'Cancelamento',
      reagendamento: 'Reagendamento',
      aniversario: 'Aniversário',
      promocao: 'Promoção'
    };
    
    return typeNames[type] || type;
  };
  
  return (
    // Substituído motion.div por div normal
    <div 
      className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200"
    >
      <div className="p-4">
        <div className="mb-2">
          <span className={`px-3 py-1.5 inline-flex text-sm font-medium rounded-md ${getTypeColor(template.type)}`}>
            {getTypeName(template.type)}
          </span>
        </div>
        
        <div className="mb-3">
          <p className="text-sm text-gray-500 whitespace-pre-line line-clamp-2">
            {previewContent}
          </p>
        </div>
        
        <div className="flex justify-between items-center pt-2">
          <button 
            onClick={() => onView(template)}
            className="text-gray-600 hover:text-gray-800 text-sm font-medium flex items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            Visualizar
          </button>
          
          <button 
            onClick={() => onEdit(template)}
            className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 0L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Editar
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
